import styled from 'styled-components';

const ProfileDiv = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: flex-start;
`;
export default ProfileDiv;
